// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactModal from "react-modal";
import * as TrackLiveTripConfig from "../../domain/store/TrackLiveTripConfig.bs.js";
import * as TrackLiveTripMarketingVMMapper from "../view-model/TrackLiveTripMarketingVMMapper.bs.js";

function TrackLiveTripMarketingModalCmp(Props) {
  var show_modal = Props.show_modal;
  var setModal = Props.setModal;
  var download_link = Props.download_link;
  var crn = Props.crn;
  var buttonHandler = function (param) {
    TrackLiveTripMarketingVMMapper.publishGAEvents(TrackLiveTripConfig.modal_cross_clicked_label, crn);
    return Curry._1(setModal, false);
  };
  return React.createElement(ReactModal, {
              isOpen: show_modal,
              onRequestClose: buttonHandler,
              className: "track-live-trip-modal",
              shouldCloseOnOverlayClick: false,
              children: React.createElement("div", {
                    className: "marketing-modal-wrapper"
                  }, React.createElement("div", {
                        className: "img-wrapper"
                      }, React.createElement("img", {
                            className: "img",
                            src: TrackLiveTripConfig.cross_icon,
                            onClick: (function (param) {
                                return buttonHandler(undefined);
                              })
                          })), React.createElement("div", {
                        className: "desc"
                      }, TrackLiveTripConfig.greet_text_title), React.createElement("div", {
                        className: "desc"
                      }, TrackLiveTripConfig.greet_text_desc), React.createElement("div", {
                        className: "offer-banner-wrapper"
                      }, React.createElement("img", {
                            className: "offer-banner",
                            alt: TrackLiveTripConfig.offer_banner_alt_text,
                            src: TrackLiveTripConfig.referral_banner
                          })), React.createElement("div", {
                        className: "offer-info"
                      }, TrackLiveTripConfig.offer_text), React.createElement("a", {
                        className: "download-app",
                        href: download_link,
                        onClick: (function (param) {
                            return TrackLiveTripMarketingVMMapper.publishGAEvents(TrackLiveTripConfig.modal_download_button_clicked_label, crn);
                          })
                      }, React.createElement("div", undefined, TrackLiveTripConfig.download_app_label)), React.createElement("div", {
                        className: "validity"
                      }, TrackLiveTripConfig.validity_text))
            });
}

var make = TrackLiveTripMarketingModalCmp;

export {
  make ,
  
}
/* react Not a pure module */
